import * as React from 'react';
import { X } from 'lucide-react';
import { cn } from '../../../utils';
import type { FilterChip } from './use-list-filters';

type ActiveFilterChipsProps = {
  chips: FilterChip[];
  removeLabel?: (chipLabel: string) => string;
  className?: string;
};

/** The filters in force, each removable with one click. Renders nothing when empty. */
export function ActiveFilterChips({ chips, removeLabel = (l) => `Remove ${l}`, className }: ActiveFilterChipsProps) {
  if (chips.length === 0) return null;
  return (
    <div className={cn('flex flex-wrap items-center gap-2', className)} role="list">
      {chips.map((chip) => (
        <span
          key={chip.key}
          role="listitem"
          className="inline-flex items-center gap-1 rounded-full border border-border bg-muted/60 py-0.5 pl-2.5 pr-1 text-xs font-medium text-foreground"
        >
          {chip.label}
          <button
            type="button"
            onClick={chip.onRemove}
            aria-label={removeLabel(chip.label)}
            className="rounded-full p-0.5 text-muted-foreground hover:bg-background hover:text-foreground"
          >
            <X className="h-3 w-3" />
          </button>
        </span>
      ))}
    </div>
  );
}
